import * as tslib_1 from "tslib";
import { AbstractMethodError, AbstractionBase } from "@awayjs/core";
import { ImageEvent } from "@awayjs/graphics";
/**
 *
 * @class away.pool.GL_ImageBase
 */
var GL_ImageBase = (function (_super) {
    tslib_1.__extends(GL_ImageBase, _super);
    function GL_ImageBase(asset, stage) {
        var _this = _super.call(this, asset, stage) || this;
        _this.usages = 0;
        _this._invalidMipmaps = true;
        _this._stage = stage;
        _this._onInvalidateMipmapsDelegate = function (event) { return _this.onInvalidateMipmaps(event); };
        _this._asset.addEventListener(ImageEvent.INVALIDATE_MIPMAPS, _this._onInvalidateMipmapsDelegate);
        return _this;
    }
    GL_ImageBase.prototype.getTexture = function () {
        if (!this._texture) {
            this._createTexture();
            this._invalid = true;
        }
        return this._texture;
    };
    /**
     *
     */
    GL_ImageBase.prototype.onClear = function (event) {
        _super.prototype.onClear.call(this, event);
        if (this._texture) {
            this._texture.dispose();
            this._texture = null;
        }
    };
    GL_ImageBase.prototype.activate = function (index, mipmap) {
        this._stage.context.setTextureAt(index, this.getTexture());
    };
    GL_ImageBase.prototype._createTexture = function () {
        throw new AbstractMethodError();
    };
    /**
     *
     */
    GL_ImageBase.prototype.onInvalidateMipmaps = function (event) {
        this._invalidMipmaps = true;
    };
    return GL_ImageBase;
}(AbstractionBase));
export { GL_ImageBase };



// WEBPACK FOOTER //
// ../dist/lib/image/GL_ImageBase.js